import { __assign, __awaiter, __generator } from "tslib";
import * as React from 'react';
var baseStyles = function () { return ({
    height: '100%',
    width: '100%',
    border: 0,
    flex: 1,
}); };
var loadingStyles = function () { return ({
    display: 'none',
}); };
var allowPermissionsMap = {
    media: ['camera', 'microphone'],
    geolocation: ['geolocation'],
    midi: ['midi'],
};
export var permissionsNotRequiringUserConsent = 'autoplay';
export var AppHostIframe = function (_a) {
    var sdkHost = _a.sdkHost, contentUrl = _a.contentUrl, frameContext = _a.frameContext, appDefinition = _a.appDefinition, title = _a.title, isLoading = _a.isLoading, userClickTime = _a.userClickTime, getRequiredPermissions = _a.getRequiredPermissions;
    var sandBoxProperties = 'allow-forms allow-popups allow-popups-to-escape-sandbox allow-pointer-lock allow-scripts allow-same-origin allow-modals allow-downloads allow-top-navigation-to-custom-protocols';
    var iframeRef = React.useRef(null);
    var allowList = useGetAllowList(getRequiredPermissions);
    React.useEffect(function () {
        // Wait for the allow list to be set before saying that the frame is ready
        if (!allowList) {
            return;
        }
        (function () { return __awaiter(void 0, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, sdkHost.setFrameAndLoadOrigin(iframeRef.current, contentUrl, appDefinition, userClickTime)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        }); })();
    }, [sdkHost, iframeRef, contentUrl, frameContext, appDefinition, allowList]);
    return (React.createElement("iframe", { "data-tid": "app-host-iframe", ref: iframeRef, style: isLoading ? __assign({}, loadingStyles()) : __assign({}, baseStyles()), sandbox: sandBoxProperties, title: title, allow: allowList }));
};
export var useGetAllowList = function (getRequiredPermissions) {
    var _a = React.useState(undefined), allowList = _a[0], setAllowList = _a[1];
    var tryInitDevicePermissions = function () { return __awaiter(void 0, void 0, void 0, function () {
        var consentedPermissions, allowedPermissions, allowedPermissionsString;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getRequiredPermissions()];
                case 1:
                    consentedPermissions = _a.sent();
                    allowedPermissions = consentedPermissions
                        .map(function (obj) { return allowPermissionsMap[obj.permission]; })
                        .flat();
                    allowedPermissionsString = allowedPermissions.concat([permissionsNotRequiringUserConsent]).join('; ');
                    setAllowList(allowedPermissionsString);
                    return [2 /*return*/];
            }
        });
    }); };
    tryInitDevicePermissions();
    return allowList;
};
//# sourceMappingURL=app-host-iframe.js.map